var map = {
	"./detox-coordinate01.png": 2849,
	"./detox-coordinate02.png": 4333,
	"./gachi-coordinate01.png": 9506,
	"./gachi-coordinate02.png": 5060,
	"./gorgeous-coordinate01.png": 9018,
	"./gorgeous-coordinate02.png": 472,
	"./yuru-coordinate01.png": 3416,
	"./yuru-coordinate02.png": 2889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6215;